<div class="summary-panel">
  <div class="summary-panel__section">
    <div class="summary-panel__heading">You are about to clone:</div>

    <div class="summary-metrics">
      <div class="summary-metrics__row">
        <div class="summary-metrics__value">{{singleCount}}</div>
        <div class="summary-metrics__label">Single project(s)</div>
      </div>

      <div class="summary-metrics__row">
        <div class="summary-metrics__value">{{ myaCount }}</div>
        <div class="summary-metrics__label">MYA project(s)</div>
      </div>

      <div class="summary-metrics__row">
        <div class="summary-metrics__value">{{ expiringCount }}</div>
        <div class="summary-metrics__label">Renewing expiring MYA project(s)</div>
      </div>
    </div>
  </div>

  <div class="summary-panel__divider"></div>

  <div class="summary-panel__notice">
    You will receive a notification once the job is done. You can view details on the cloning dashboard.
  </div>

  <!-- <div class="summary-panel__section mt-4">
    <div class="summary-panel__heading mb-3">Choose where you want to be notified:</div>

    <div class="summary-checkbox-row">
      <label class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [ngModel]="notifyEmail"
          (ngModelChange)="notifyEmailChange.emit($event)"
        />
        <span class="form-check-label">Email</span>
      </label>

      <label class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [ngModel]="notifySms"
          (ngModelChange)="notifySmsChange.emit($event)"
        />
        <span class="form-check-label">SMS</span>
      </label>

      <label class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [ngModel]="notifyInApp"
          (ngModelChange)="notifyInAppChange.emit($event)"
        />
        <span class="form-check-label">In App</span>
      </label>
    </div>
  </div> -->

  <div class="summary-panel__section mt-4">
    <div class="summary-panel__heading mb-3">Notify the following:</div>

    <div class="summary-checkbox-row">
      <label class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [ngModel]="notifySuperAdmin"
          (ngModelChange)="notifySuperAdminChange.emit($event)"
        />
        <span class="form-check-label">Super Admin</span>
      </label>

      <label class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          [ngModel]="notifyAdmins"
          (ngModelChange)="notifyAdminsChange.emit($event)"
        />
        <span class="form-check-label">Admins</span>
      </label>
    </div>
  </div>
</div>